import { api } from "@/services/api";

import type { LoginInput, RegisterInput, User } from "./types";

export const authApi = {
  me: (signal?: AbortSignal) => api.get<User>("/auth/me/", { signal }),
  login: (input: LoginInput) => api.post<User>("/auth/login/", input),
  register: (input: RegisterInput) => api.post<User>("/auth/register/", input),
  logout: () => api.post<null>("/auth/logout/"),
};